import type { TransitionMeetingDetailsResource } from "api/generated";
import type { TransitionMeetingDetails } from "meetings/advisory/types";
import { answerOptionFromDto, answerTypeFromDto } from "./answerOption.mapper";
import { timeframeSettingsFromDto } from "./timeframe.mapper";

export const meetingDetailsFromDto = (
  dto: TransitionMeetingDetailsResource,
): TransitionMeetingDetails => ({
  id: dto.id,
  name: dto.name,
  status: dto.status as TransitionMeetingDetails["status"],
  meetingType: "transition_meeting",
  planning: {
    timeframeSettings: timeframeSettingsFromDto(
      dto.planning.timeframe_settings,
    ),
  },
  question: {
    message: dto.question.message,
    questionPrompt: dto.question.question_prompt,
    answerType: answerTypeFromDto(dto.question.answer_type),
    ratingOptions: dto.question.rating_options.map(answerOptionFromDto),
  },
  mentorClasses: dto.mentor_classes,
  subjects: dto.subjects,
});
